import { ErrorContainer } from '../../../pages/UserSearch/UserSearch.styles';
import { StyledErrorIconContainer, StyledTypographyContainer } from '../Retry/Retry.styles';
import { Box, Button, Icon, Typography } from '@hiiretail/synergy-ui';
import { EntityNotFoundComponent } from './EntityNotFound.types';
import { useHistory } from 'react-router-dom';

export const EntityNotFound: EntityNotFoundComponent = ({ itemTitle, error, backRoute }) => {
  const history = useHistory();
  const handleClick = () => history.push(backRoute as string);

  return error ? (
    <ErrorContainer
      container
      item
      flex="1 1 auto"
      alignItems="center"
      justifyContent="center"
      direction="column"
    >
      <StyledErrorIconContainer container size="xlg">
        <Icon.WarningRound color={() => '#F44336'} size="lg" />
      </StyledErrorIconContainer>

      <StyledTypographyContainer container direction="column" alignItems="center" size="xlg">
        <Typography variant="header3" textAlign="center">
          {itemTitle} not found.
        </Typography>
        <Box mb={2}>
          <Typography textAlign="center">Try other search fields and check spelling</Typography>
        </Box>
        {backRoute && (
          <Button type="button" onClick={handleClick}>
            Go back
          </Button>
        )}
      </StyledTypographyContainer>
    </ErrorContainer>
  ) : null;
};
